/** Per-kind data-correction form layout for BondDataCorrectionFormBase. */
import {
  buildDataCorrectionFlatFields,
  buildDataCorrectionHeading,
  buildDataCorrectionListSection,
  buildDataCorrectionNestedFields,
  buildInitialMiddleLastFields,
  buildListAfterReason,
  buildPersonNameFields,
} from './dataCorrectionSchemaHelpers';

export const DATA_CORRECTION_FORM_CONFIG = {
  va: {
    useNumberFormat: false,
    sections: [
      buildDataCorrectionHeading('Beneficiary Information'),
      buildDataCorrectionNestedFields('beneficiary', buildPersonNameFields()),
    ],
    listAfterReason: buildListAfterReason({
      title: 'Principals',
      path: 'principals',
      nameKey: 'name',
      labelPrefix: 'Principal',
    }),
    reasonBeforeList: true,
  },
  trustee: {
    useNumberFormat: false,
    sections: [
      buildDataCorrectionHeading('Trustee Information'),
      buildDataCorrectionFlatFields([
        { key: 'legalName', label: 'Legal Name' },
        { key: 'trustName', label: 'Trust Name' },
      ]),
      buildDataCorrectionListSection({
        title: 'Trustees',
        path: 'trustees',
        nameKey: 'name',
        labelPrefix: 'Trustee',
      }),
    ],
    reasonBeforeList: false,
  },
  probate: {
    useNumberFormat: true,
    sections: [
      buildDataCorrectionHeading('Deceased Information'),
      buildDataCorrectionNestedFields('deceased', buildInitialMiddleLastFields('Deceased')),
      buildDataCorrectionListSection({
        title: 'Principal Information',
        path: 'principals',
        nameKey: 'name',
        labelPrefix: 'Principal',
      }),
    ],
    reasonBeforeList: false,
  },
  guardianship: {
    useNumberFormat: true,
    sections: [
      buildDataCorrectionHeading('Ward Information'),
      buildDataCorrectionNestedFields('ward', buildInitialMiddleLastFields('Ward')),
      buildDataCorrectionListSection({
        title: 'Principal Information',
        path: 'guardians',
        nameKey: 'guardian_name',
        labelPrefix: 'Guardian',
      }),
    ],
    reasonBeforeList: false,
  },
};
